const isRealLocation = (p)=>typeof p.lat === 'number' && typeof p.lon === 'number' && p.lat >= -90 && p.lat <= 90 && p.lon >= -180 && p.lon <= 180
;

export { isRealLocation };
//# sourceMappingURL=is-real-location.js.map
